
import React, { useEffect } from "react"
import withRouter from "components/Common/withRouter"
import { del } from "../../helpers/api_helper"
//redux
import { useNavigate, useParams } from "react-router-dom"
import { REMOVE_EMERGENCY_SUB_TYPES } from "helpers/api_endpoints"

function RemoveEmergencySubType() {
  const history = useNavigate()
  const params = useParams()
  const id = params.id
  const navigate = useNavigate()

  useEffect(() => {
    del(REMOVE_EMERGENCY_SUB_TYPES, { id })
      .then(response => {
        navigate("/emergency-sub-types", {
          state: { successMsg: "Emergency Sub Type Deleted Successfully" },
        })
      })
      .catch(error => {
        console.log(error)
      })
  })
  return <React.Fragment>Removed</React.Fragment>
}

export default RemoveEmergencySubType 